<template>
  <div class="kpi-card">
    <p class="kpi-card__title">
      {{ title }}
      <InfoTooltip
        v-if="info"
        :label="title"
        :text="info"
      />
    </p>
    <div class="kpi-card__body">
      <span
        class="kpi-card__value"
        :style="{ color: valueColor || undefined }"
        :class="{
          'kpi-card__value--positive': positive,
          'kpi-card__value--negative': negative,
        }"
      >
        {{ value }}
      </span>
      <span
        v-if="complement"
        class="kpi-card__complement"
        :class="complementVariant ? `kpi-card__complement--${complementVariant}` : ''"
      >
        {{ complement }}
      </span>
      <span
        v-if="description"
        class="kpi-card__description"
      >
        {{ description }}
      </span>
    </div>
  </div>
</template>

<script>
import InfoTooltip from '../../common/InfoTooltip.vue'

export default {
  name: 'KpiCard',
  components: { InfoTooltip },
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], required: true },
    complement: { type: String, default: '' },
    complementVariant: {
      type: String,
      default: '',
      validator: value => ['', 'green', 'red', 'neutral'].includes(value),
    },
    description: { type: String, default: '' },
    info: { type: String, default: '' },
    positive: { type: Boolean, default: false },
    negative: { type: Boolean, default: false },
    valueColor: { type: String, default: '' },
  },
}
</script>

<style scoped lang="scss">
.kpi-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  flex: 1;
  align-self: stretch;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Roboto', sans-serif;

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: rgba(70, 70, 70, 1);
    margin: 0 0 10px;
  }

  &__body {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
  }

  &__value {
    font-size: 28px;
    font-weight: bold;
    color: #7f1a54;
    line-height: 1;

    &--positive {
      color: rgba(20, 85, 40, 1);
    }

    &--negative {
      color: rgba(150, 0, 18, 1);
    }
  }

  &__complement,
  &__description {
    font-size: 14px;
    color: rgba(90, 90, 90, 1);
  }

  &__complement--green {
    padding: 0 8px;
    border-radius: 4px;
    background: rgba(34, 114, 58, 1);
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    min-width: 43px;
    height: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__complement--red {
    padding: 0 8px;
    border-radius: 4px;
    background: rgba(218, 51, 71, 1);
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    min-width: 43px;
    height: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__complement--neutral {
    padding: 0 8px;
    border-radius: 4px;
    background: #5a5a5a;
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    min-width: 43px;
    height: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
